export const KEYS = ['company_id', 'contact_id', 'role_desc'];

export interface MixedEntityConfigDecomposer {
  parentIdExtractor: string | Function;
  childrenIdExtractor: string | Function;
}

const keyExtractor = (ctx, extractor) => {
  return typeof extractor === 'function' ? extractor(ctx) : ctx[extractor];
};

/**
 *
 * @param config data to build parent, children relationships
 * @param elements  array of objects to be grouped
 * sample :
 * config = {
 *   parentIdExtractor: ctx => `${ctx['company_id']}.${ctx['role_desc']}`,
 *   childrenIdExtractor: 'contact_id',
 * };
 */
export const groupCompaniesContacts = (elements: any[], config: MixedEntityConfigDecomposer = null) => {
  if (!config) {
    config = {
      parentIdExtractor: (ctx: any) => `${ctx['company_id']}.${ctx['role_desc']}`,
      childrenIdExtractor: 'contact_id',
    };
  }

  const parentElements = {};
  (elements || []).forEach((element: any[], index) => {
    const parentKey = keyExtractor(element, config.parentIdExtractor);
    // Create company if it doesn't  exists
    if (!parentElements[parentKey]) {
      // adding index to be used in return statement
      // so we return objects as they were created
      parentElements[parentKey] = { ...element, index, children: [], isContainer: true };
    }
    const childrenKey = keyExtractor(element, config.childrenIdExtractor);
    // if object is also a valid contact, then append to the element
    if (!!childrenKey && parentElements[parentKey]) {
      // initialized as empty by default
      parentElements[parentKey].children = [...parentElements[parentKey].children, element];
    }
  });

  return (
    Object.values(parentElements)
      // ADDING SORT TO RETURN OBJECTS AS THEY WERE CREATED
      .sort((a: any, b: any) => a.index - b.index)
  );
};
